import { IClassroomGrammarData } from '@datatype/iyagigo/api-type';
import { IGrammarStage, IGrammarTopic } from '@datatype/iyagigo/type';

export const groupClassroomGrammars = (grammars: IClassroomGrammarData[]): IGrammarStage[] => {
  const stages = new Map<string, IGrammarStage>();

  grammars.forEach((grammar) => {
    let stage = stages.get(grammar.stageKey);
    if (!stage) {
      stage = {
        key: grammar.stageKey,
        order: grammar.stageOrder,
        name: grammar.stageName,
        topics: [],
      };
      stages.set(grammar.stageKey, stage);
    }

    let topic: IGrammarTopic | undefined = stage.topics.find((item) => item.key === grammar.topicKey);
    if (!topic) {
      topic = {
        key: grammar.topicKey,
        order: grammar.topicOrder,
        name: grammar.topicName,
        grammars: [],
      };
      stage.topics.push(topic);
    }

    topic.grammars.push(grammar);
  });

  return Array.from(stages.values())
    .sort((a, b) => a.order - b.order)
    .map((stage) => ({
      ...stage,
      topics: stage.topics
        .sort((a, b) => a.order - b.order)
        .map((topic) => ({
          ...topic,
          grammars: topic.grammars.sort((a, b) => a.grammarOrder - b.grammarOrder),
        })),
    }));
};
